// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__2KFP8","label":"LabeledBox_label__16ySG"};